import React from 'react';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import { safeHTML } from '../../../utils/safeHTML';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import { useModal } from '../../../hooks/useModal';
import { procedureModal } from '../../../constants/copyright-modals';
import { useContent } from '../../../redux/reducer/content';
import useStateControls from '../../../hooks/useStateControls';
import { useUser } from '../../../redux/reducer/user';
import classNames from 'classnames';
import { useTranslation } from '../../../translations';

const { goProcedure, disabledNote, enabledNote, noMoneyData } = procedureModal;

const ProcedureModal = React.forwardRef(function ProcedureModal(
  { callbacks, isHaveRoutines, procedureRemainder },
  ref,
) {
  const { addModal, closeModal } = useModal();
  const { setState } = useStateControls();
  const { beautyRoutine } = useContent();
  const { profile } = useUser();
  const { t } = useTranslation();

  const close = () => closeModal({ type: 'all' });

  const noMoneyModal = () => {
    close();
    addModal({ type: 'buyModal', props: noMoneyData });
  };

  const buyRoutine = () => {
    if (profile?.money >= beautyRoutine?.cost) {
      close();
      setState('procedureGame');
      return;
    }
    noMoneyModal();
  };

  return (
    <CustomModal animation={['fade', 'scale', 'scale-bounce']}>
      <div className={'procedure-modal'} ref={ref}>
        <div className={'procedure-modal__bg'} onClick={close} />
        <div className={'procedure-modal__content'}>
          {beautyRoutine?.image && (
            <div className='procedure-modal__image'>
              <img src={beautyRoutine?.image} alt={beautyRoutine?.brand} />
            </div>
          )}
          <h2 className={'procedure-modal__title'}>{safeHTML(beautyRoutine?.title)}</h2>
          <p className={'procedure-modal__text'}>{safeHTML(beautyRoutine?.description)}</p>

          <div className={'procedure-modal__disabled-note'}>
            {(isHaveRoutines ? enabledNote : disabledNote)(procedureRemainder, t)}
          </div>

          <CustomButton
            disabled={!isHaveRoutines}
            className={classNames('procedure-modal__button custom-button_price custom-button_price-big', {
              'custom-button_disabled': !isHaveRoutines,
            })}
            text={goProcedure}
            onClick={buyRoutine}
          />
        </div>
      </div>
    </CustomModal>
  );
});
export default ProcedureModal;
ProcedureModal.propTypes = {};
